import { Box, Button } from '@mui/material'
import { getBiologicalCertificate } from '../service'
import { downloadFile } from '../../../../helpers/downloadFile'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../redux/store'
import { getCertificatesData, clearReportsData, selectCustomerNumber } from '../slice'
import { selectCertificateCount } from '../slice'
import { selectLoadingState } from '../slice'
import { Download as DownloadIcon } from '@mui/icons-material'
import { addError } from '../../../../redux/alerts'
import useCustomer from '../../../../hooks/useCustomer'
import { LoadingState } from '../../../../types'

const Certificates = () => {
  const customer = useCustomer()

  const dispatch = useAppDispatch()

  const loadingState = useAppSelector(selectLoadingState)
  const reportsCustomer = useAppSelector(selectCustomerNumber)
  const certificateCount = useAppSelector(selectCertificateCount)

  const [downloading, setDownloading] = useState(false)

  useEffect(() => {
    const needsData = Boolean(customer.customer_number) && !reportsCustomer && loadingState.certificates === LoadingState.NotStarted
    const clearData = Boolean(customer.customer_number) && reportsCustomer && reportsCustomer !== customer.customer_number

    if (needsData) {
      dispatch(getCertificatesData(customer.customer_number))
    } else if (clearData) {
      dispatch(clearReportsData())
    }
  }, [reportsCustomer, customer.customer_number, loadingState.certificates])

  useEffect(() => {
    if (loadingState.certificates === 'error') {
      dispatch(addError('There was a problem downloading this report'))
    }
  }, [loadingState.certificates])

  const exportBiologicalCertificate = async () => {
    setDownloading(true)

    const { customer_number, doctor_name } = customer

    try {
      const blob = await getBiologicalCertificate(customer_number, doctor_name)
      const url = URL.createObjectURL(blob)
      const fileName = 'biological_certificate.pdf'

      await downloadFile({ url, fileName, isBlobURL: true })
    } catch (error) {
      console.error(error)
      dispatch(addError('There was a problem downloading this report'))
    }

    setDownloading(false)
  }

  return (
    <>
      {loadingState.certificates == 'done' && (
        <Box className="wrapper">
          {certificateCount ? (
            <>
              <h4>Certificates for Biological Monitoring</h4>
              <Button
                startIcon={<DownloadIcon />}
                variant='contained'
                onClick={exportBiologicalCertificate}
                disabled={downloading}
              >
                {!downloading ? 'Download Certificate' : 'Downloading...'}
              </Button>
            </>
          ) : (
            <div className='p-16 center'>
              You don't have any certificates
            </div>
          )}
        </Box>
      )}
    </>
  )
}

export default Certificates